// extracted by mini-css-extract-plugin
module.exports = {"container":"JobTitle_container__3H1Lt","date":"JobTitle_date__Kl9S2","title":"JobTitle_title__10XGY","sending":"JobTitle_sending__1ffed"};